/**
 * @generated SignedSource<<228c3ab4e9c4e8f1a866f945eb366054>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DesignAdaptAlghoritm = "FIT_WITH_BACKGROUND" | "NONE" | "PERCENTAGE";
export type designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation$variables = {
  modelId: number;
  templateId: string;
  type: DesignAdaptAlghoritm;
};
export type designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation$data = {
  readonly setTemplateAdaptItemsToVariants: {
    readonly colors: ReadonlyArray<{
      readonly colorID: number;
      readonly isDefault: boolean;
      readonly name: string | null;
    } | null>;
    readonly designTemplateId: number;
    readonly id: string;
    readonly name: string;
    readonly previewUrl: string;
  };
};
export type designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation = {
  response: designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation$data;
  variables: designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelId",
        "variableName": "modelId"
      },
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "templateId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "DesignTemplate",
    "kind": "LinkedField",
    "name": "setTemplateAdaptItemsToVariants",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "designTemplateId",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignTemplateColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "e4ea7ae2937aa2a317a9938ecba5919b",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesSetTemplateAdaptItemToVariantsMutation(\n  $modelId: Long!\n  $templateId: ID!\n  $type: DesignAdaptAlghoritm!\n) {\n  setTemplateAdaptItemsToVariants(modelId: $modelId, templateId: $templateId, type: $type) {\n    id\n    designTemplateId\n    name\n    previewUrl\n    colors {\n      colorID\n      name\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "72bcf4867a1693f1bf078986a6aaec70";

export default node;
